<body class="ltr leftmenu">
    <!-- <form autocomplete="off" novalidate > -->
    <!-- Main Content-->
    <form class="main-content side-content" [formGroup]="CourseSCEditForm">
        <div class="main-container container-fluid">
            <div class="inner-body">
                <!-- Page Header -->
                <!-- <div class="page-header">
                    <div>
                        <h2 class="main-content-title tx-24 mg-b-5">Course Edit Control</h2>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Edit Course By Supervisor
                            </li>
                        </ol>
                    </div>
                </div> -->
                <div class="row row-sm add-form">
                    <div class="col-lg-12 col-md-12">
                        <div class="card custom-card">
                            <div class="card-body">

                                <!-- <div>
                                        <h3 class="main-content-label mb-1">
                                            <b>Course Edit Control</b>
                                        </h3>
                                        <p class="text-muted card-sub-title mb-0">
                                            Edit Course By Supervisor </p>
                                    </div> -->
                                <div class=" d-flex align-items-center pl-3">
                                    <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                                    <div class="ml-2">
                                        <h3 class="main-content-label mb-1"><b>
                                                Course Edit Control
                                            </b></h3>
                                        <p class="text-muted card-sub-title mb-0">
                                            Edit Course By Supervisor
                                        </p>
                                    </div>
                                </div>
                                <hr class="mt-1 mb-2">
                                <div class="row clearfix mt-3">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Course Available</mat-label>
                                                    <mat-select formControlName="CEcShId" #select39011 required
                                                        placeholder="Course Available" class="colorblack">
                                                        <mat-select-filter *ngIf="select39011.focused"
                                                            [placeholder]="'Course Available'"
                                                            [displayMember]="'CoName'" [array]="CourseAList"
                                                            (filteredReturn)="filteredCourseAList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCourseAList"
                                                             [value]="item.CShId"
                                                            (click)="reset(item.CShId,item.CoCode)">
                                                            {{ item | displayValue:'CoCode':'CoName' }}
                                                        </mat-option>
                                                        <!-- (click)="fetchSupCourseEditRecord()" -->
                                                        <!-- {"EmId":700,"EmCode":"06068","EmName":"Ki Course Test","EmShName":"N EXAM"} -->
                                                        <!-- here i am passing em id ask developer do u need emcode or emid -->
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="CourseSCEditForm.controls['CEcShId'].touched && CourseSCEditForm.controls['CEcShId'].errors?.required">
                                                       Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> Input</mat-label>
                                                    <mat-select formControlName="FrontCEcInCode" #select3902
                                                        placeholder=" Input" class="colorblack">
                                                        <mat-select-filter *ngIf="select3902.focused"
                                                            [placeholder]="' Input'" [displayMember]="'InDesc'"
                                                            [array]="CourseInputList"
                                                            (filteredReturn)="filteredCourseInputList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCourseInputList"
                                                            (click)="fetchSupCourseEditRecord()" [value]="item.InCode">
                                                            {{item.InDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-3">
                                            <button (click)="addNew()" type="button"
                                                class="btn btn-primary  me-2 btn-icon-text floatright btn-raised g-bg-blush2">
                                                New Record </button>
                                        </div> -->
                                    <div class="col-sm-4 ">
                                        <button type="button"
                                            class="btn width btn-primary btn-icon-text floatright mt-1"
                                            (click)="addNew()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/plus.gif"
                                                    style="margin-right: 3px;">
                                                New
                                            </span>
                                        </button>
                                        <button type="button" (click)="printAll()"
                                            class="btn btn-primary btn-icon-text floatright mt-1 mr-3">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                Print
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="showDiv" class="row clearfix mt-1">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Input</mat-label>
                                                    <mat-select [disabled]="updateReadonly" formControlName="CEcInCode" #select39022 required
                                                        placeholder="Input" class="colorblack">
                                                        <mat-select-filter *ngIf="select39022.focused"
                                                            [placeholder]="' Input'" [displayMember]="'InDesc'"
                                                            [array]="CourseInputList"
                                                            (filteredReturn)="filteredCourseInputList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCourseInputList"
                                                            [value]="item.InCode">
                                                            {{item.InDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="CourseSCEditForm.controls['CEcInCode'].touched && CourseSCEditForm.controls['CEcInCode'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        Description
                                                    </mat-label>
                                                    <input formControlName="CEcDesc"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        type="text" placeholder="Description" matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="showDiv" class="row clearfix">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Operator</mat-label>
                                                    <mat-select formControlName="CEcOpId" #select39023 [disabled]="updateReadonly"
                                                        placeholder="Operator" class="colorblack">
                                                        <mat-select-filter *ngIf="select39023.focused"
                                                            [placeholder]="'Operator'" [displayMember]="'LoginFullName'"
                                                            [array]="userList"
                                                            (filteredReturn)="filtereduserList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filtereduserList"
                                                            [value]="item.LoginId">
                                                            {{item.LoginFullName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="CourseSCEditForm.controls['CEcOpId'].touched && CourseSCEditForm.controls['CEcOpId'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-1">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        List
                                                    </mat-label>
                                                    <input formControlName="CEcListNo" [readonly]="updateReadonly"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        type="text" placeholder="List" matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Status</mat-label>
                                                    <mat-select formControlName="CEcStatus" #select3900
                                                        placeholder="statusList" class="colorblack">
                                                        <mat-select-filter *ngIf="select3900.focused"
                                                            [placeholder]="'statusList'" [displayMember]="'name'"
                                                            [array]="statusList"
                                                            (filteredReturn)="filteredstatusList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredstatusList"
                                                            [value]="item.id">
                                                            {{item.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row ">
                                        <div class="col-sm-12 prpl">
                                            <button type="button" *ngIf="updateButton && CourseEditDelete"
                                                class="btn btn-primary btn-icon-text floatright mt-1"
                                                (click)="delete()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/trash.gif"
                                                        style="margin-right: 5px;">
                                                    Delete
                                                </span>
                                            </button>
                                            <button type="button" [disabled]="submitButton && CourseEditCreate" (click)="print()"
                                                class="btn btn-primary btn-icon-text floatright mt-1 mr-3">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/printer.gif"
                                                        style="margin-right: 7px;">
                                                    Edit List
                                                </span>
                                            </button>
                                            <button type="button" *ngIf="updateButton && CourseEditUpdate"
                                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1"
                                                (click)="updateCheck()" [disabled]="updateDisable">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/edit1.gif"
                                                        style="margin-right: 7px;">
                                                    Update
                                                </span>
                                            </button>
                                            <button type="button" *ngIf="submitButton && CourseEditCreate"
                                                class="btn wd btn-primary btn-icon-text floatright mr-3 mt-1"
                                                (click)="submit()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/save.gif"
                                                        style="margin-right: 5px;">
                                                    Save
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                                <hr>
                                <div *ngIf="Table" class="row clearfix">
                                    <div class="col-sm-12">
                                        <table id="datatable" class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <!-- <th class="f600">
                                                            EC
                                                        </th> -->
                                                    <!-- <th class="f600">
                                                                Input
                                                            </th> -->
                                                    <th class="f600">
                                                        List
                                                    </th>
                                                    <th class="f600">
                                                        Description
                                                    </th>
                                                    <th class="f600 ">
                                                        Operator
                                                    </th>
                                                    <th class="f600">
                                                        Opened
                                                    </th>
                                                    <th class="f600">
                                                        Status
                                                    </th>
                                                    <th class="f600 ">
                                                        Updated
                                                    </th>
                                                    <th *ngIf="FeesNotPaid">
                                                        View
                                                    </th>
                                                    <!-- 
                                                            <th class="f600 text-center">
                                                                Action
                                                            </th> -->
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr class="a" *ngFor="let course of courseRecords;"
                                                    (click)="prepopulate(course)">
                                                    <!-- <td>{{course.CEcId}} </td> -->
                                                    <!-- <td>{{course.input}} </td> -->
                                                    <td> {{course.CEcListNo}} </td>
                                                    <td>{{course.CEcDesc}} </td>
                                                    <td>{{course.L1}} </td>
                                                    <td> {{course.L2}} </td>
                                                    <td *ngIf="course.CEcStatus == 'U'">
                                                        Updated
                                                      </td>
                                                      <td *ngIf="course.CEcStatus == 'O'">
                                                          Open
                                                       </td>
                                                    <!-- <td> {{course.CEcStatus}} </td> -->
                                                    <td> {{course.L3}} </td>
                                                    <td *ngIf="FeesNotPaid && course.CEcInCode == 51 && course.CEcStatus == 'O'" (click)="openGrid()">
                                                        <i class="fa fa-eye eye"></i>
                                                    </td>
                                                    <!-- <td> {{course.updated}} </td>
                                                            <td class="text-center">

                                                                <a class="btn-floating" title="Edit">
                                                                    <i class="fa fa-edit" ></i>
                                                                </a>
                                                                <a class="btn-floating" title="Delete">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </td> -->
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                                <div *ngIf="updateDisableFeePending">
                                    <p><b class="red">Note : {{UpdateError}}</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- list of Course end  -->
            </div>
        </div>
    </form>
    <!-- </form> -->
</body>